exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cof-field[data-v-1bc3cf0a] {\n  margin-right: 5px;\n}\n.errors[data-v-1bc3cf0a] {\n  color: #ff0000 !important;\n}\n.key-wrap[data-v-1bc3cf0a] {\n  max-width: 100px;\n  word-wrap: break-word;\n}\n.fee-checkbox[data-v-1bc3cf0a] {\n  -webkit-appearance: checkbox;\n}\n.updateAt[data-v-1bc3cf0a] {\n  font-size: 10px;\n  width: 155px;\n}\n.form-max div[data-v-1bc3cf0a] {\n  width: 100%;\n}", ""]);

// exports
